export const lista_estados = {
    "-1":{
        "nombre":"Error Desconocido",
        "descripcion":"Error Desconocido",
        "icono":"spriteERROR_DESCONOCIDO"
    },
    "0":{
        "nombre":"OK",
        "descripcion":"La consulta http tuvo respuesta satisfactoria.",
        "icono":"spriteOK"
    },
    "1":{
        "nombre":"Error de Configuración",
        "descripcion":"Error en la Configuración del Monitoreo",
        "icono":"spriteERROR_CONFIGURACION"
    },
    "2":{
        "nombre":"Error fatal en el monitoreo.",
        "descripcion":"FATAL",
        "icono":"spriteERROR_FATAL_EN_EL_MONITOREO."
    },
    "3":{
        "nombre":"Timeout",
        "descripcion":"Tiempo de espera agotado o timeout",
        "icono":"spriteTIMEOUT"
    },
    "4":{
        "nombre":"No se resolvió URL",
        "descripcion":"No se conoce dirección IP del host",
        "icono":"spriteURL_NORESUELTO"
    },
    "5":{
        "nombre":"Periodo sin monitoreo",
        "descripcion":"El objetivo no fue monitoreado en ese período",
        "icono":"spriteNO_MONITOREO"
    },
    "6":{
        "nombre":"Timeout de la Página",
        "descripcion":"Timeout en la Descarga Completa de la Página",
        "icono":"spriteTIMEOUT_PAGINA"
    },
    "7":{
        "nombre":"Timeout infinito",
        "descripcion":"Timeout intentando en modo persistente infinito",
        "icono":"spriteTIMEOUT_INFINITO"
    },
    "8":{
        "nombre":"OK",
        "descripcion":"OK al segundo intento",
        "icono":"spriteOK_AL_SEGUNDO_INTENTO"
    },
    "9":{
        "nombre":"DNS OK No autoritativo",
        "descripcion":"La respuesta del DNS no es autoritativa, es decir, la respuesta proviene de tablas temporales (cache) de un DNS no oficial del dominio.",
        "icono":"spriteOK_DNS_NoAutoritativo"
    },
    "10":{
        "nombre":"Sin dominio",
        "descripcion":"Dominio consultado no existe",
        "icono":"spriteSIN_DOMINIO"
    },
    "11":{
        "nombre":"Sin nombre",
        "descripcion":"Nombre consultado no existe",
        "icono":"spriteSIN_NOMBRE"
    },
    "12":{
        "nombre":"Sin servidor",
        "descripcion":"DNS consultado no existe",
        "icono":"spriteSIN_SERVIDOR"
    },
    "13":{
        "nombre":"Error de contenido",
        "descripcion":"El contenido del servicio y/o aplicación web, App Mobile o Mensaje del servidor IVR no coincide con el patrón definido. Esto significa que se obtiene un resultado distinto a lo esperado.",
        "icono":"spriteERROR_CONTENIDO"
    },
    "14":{
        "nombre":"DNS OK autoritativo",
        "descripcion":"DNS Ok Autoritativo",
        "icono":"spriteOK_DNS"
    },
    "15":{
        "nombre":"Sin respuesta",
        "descripcion":"Servidor no responde",
        "icono":"spriteSIN_RESPUESTA"
    },
    "16":{
        "nombre":"Sin respuesta",
        "descripcion":"Servidor no responde",
        "icono":"spriteSIN_RESPUESTA"
    },
    "17":{
        "nombre":"Servidor Correo OK",
        "descripcion":"Fue posible obtener conexión con el servidor de correo.",
        "icono":"spriteSERVIDOR_CORREO_OK"
    },
    "18":{
        "nombre":"Error Autenticación",
        "descripcion":"Problema de Autenticación",
        "icono":"spriteERROR_AUTENTICACION"
    },
    "19":{
        "nombre":"Error SMTP inseguro",
        "descripcion":"Relay abierto",
        "icono":"spriteERROR_SMTP"
    },
    "20":{
        "nombre":"Downtime Funcional",
        "descripcion":"Downtime Funcional",
        "icono":"spriteDOWNTIME_FUNCIONAL"
    },
    "21":{
        "nombre":"TXT vacío",
        "descripcion":"En consulta de DNS CHAOS, el campo TXT se encuentra vacio.",
        "icono":"spriteTEXTO_VACIO"
    },
    "22":{
        "nombre":"Campo no disponible",
        "descripcion":"Campo CHAOS no disponible para consulta en DNS.",
        "icono":"spriteCAMPO_NO_DISPONIBLE"
    },
    "23":{
        "nombre":"Patrón de error encontrado",
        "descripcion":"Patrón de error conocido encontrado",
        "icono":"spritePATRON_DE_ERROR_ENCONTRADO"
    },
    "24":{
        "nombre":"Certificado inválido",
        "descripcion":"Certificado SSL Inválido",
        "icono":"spriteCERTIFICADO_INVALIDO"
    },
    "25":{
        "nombre":"Faltaron Elementos",
        "descripcion":"Faltaron Elementos por Descargar",
        "icono":"spriteFALTARON_ELEMENTOS"
    },
    "26":{
        "nombre":"Terminado con errores",
        "descripcion":"Existieron errores en el monitoreo, pero pueden no ser de importancia",
        "icono":"spriteTERMINADO_CON_ERRORES"
    },
    "27":{
        "nombre":"Timeout Javascript",
        "descripcion":"Tiempo de espera agotado en paso Javascript",
        "icono":"spriteTIMEOUT_JS"
    },
    "28":{
        "nombre":"Error previo",
        "descripcion":"Paso no ejecutado por error anterior",
        "icono":"spriteERROR_PREVIO"
    },
    "29":{
        "nombre":"Error USSD",
        "descripcion":"El paso devolvió un error USSD desde el operador",
        "icono":"spriteERROR_USSD"
    },
    "30":{
        "nombre":"Mail OK",
        "descripcion":"Mail Recibido OK",
        "icono":"spriteMAIL_OK"
    },
    "31":{
        "nombre":"Error correo",
        "descripcion":"Error en envio de correo",
        "icono":"spriteERROR_CORREO"
    },
    "32":{
        "nombre":"Error Conex. MailBox",
        "descripcion":"Error Conex. MailBox",
        "icono":"spriteERROR_CONEXION_MAILBOX"
    },
    "33":{
        "nombre":"Timeout",
        "descripcion":"Timeout en recepción de correo",
        "icono":"spriteTIMEOUT"
    },
    "34":{
        "nombre":"Error en la recepción del correo",
        "descripcion":"Error en la recepción del correo por parte del servidor",
        "icono":"spriteERROR_RECEPCION_MAIL"
    },
    "35":{
        "nombre":"Error de contenido DNS",
        "descripcion":"El contenido de la respuesta del DNS no coincide con el patron",
        "icono":"spriteERROR_CONTENIDO_DNS"
    },
    "36":{
        "nombre":"Error conocido encontrado en DNS",
        "descripcion":"El contenido de la respuesta del DNS corresponde a un error conocido",
        "icono":"spriteERROR_CONTENIDO_CONOCIDO_DNS"
    },
    "40":{
        "nombre":"Error SOAP",
        "descripcion":"Error SOAP en el servidor",
        "icono":"spriteERROR_SOAP"
    },
    "60":{
        "nombre":"Error dos patrones",
        "descripcion":"No se encontró ninguno de los dos patrones buscados",
        "icono":"spriteERROR_DOS_PATRONES"
    },
    "62":{
        "nombre":"Error primer patrón",
        "descripcion":"No se encontró el primer patrón buscado",
        "icono":"spriteERROR_PRIMER_PATRON"
    },
    "64":{
        "nombre":"Error segundo patrón",
        "descripcion":"No se encontró el segundo patrón buscado",
        "icono":"spriteERROR_SEGUNDO_PATRON"
    },
    "66":{
        "nombre":"Error SIF",
        "descripcion":"No se encontró el patrón SIF",
        "icono":"spriteERROR_SIF"
    },
    "67":{
        "nombre":"Error B2B",
        "descripcion":"No se encontró el patrón B2B",
        "icono":"spriteERROR_B2B"
    },
    "68":{
        "nombre":"Error B2B-SIF",
        "descripcion":"No se encontró el patrón B2B-SIF",
        "icono":"spriteERROR_B2B-SIF"
    },
    "69":{
        "nombre":"Error SAB",
        "descripcion":"No se encontró el patrón SAB",
        "icono":"spriteERROR_SAB"
    },
    "70":{
        "nombre":"Error SAB-SIF",
        "descripcion":"No se encontró el patrón SAB-SIF",
        "icono":"spriteERROR_SAB-SIF"
    },
    "71":{
        "nombre":"Error SAB-B2B",
        "descripcion":"No se encontró el patrón SAB-B2B",
        "icono":"spriteERROR_SAB-B2B"
    },
    "72":{
        "nombre":"Error SAB-B2B-SIF",
        "descripcion":"No se encontró el patrón SAB-B2B-SIF",
        "icono":"spriteERROR_SAB-B2B-SIF"
    },
    "73":{
        "nombre":"Error SRX",
        "descripcion":"No se encontró el patrón SRX",
        "icono":"spriteERROR_SRX"
    },
    "74":{
        "nombre":"Error SRX-SIF",
        "descripcion":"No se encontró el patrón SRX-SIF",
        "icono":"spriteERROR_SRX-SIF"
    },
    "75":{
        "nombre":"Error SRX-B2B",
        "descripcion":"No se encontró el patrón SRX-B2B",
        "icono":"spriteERROR_SRX-B2B"
    },
    "76":{
        "nombre":"Error SRX-B2B-SIF",
        "descripcion":"No se encontró el patrón SRX-B2B-SIF",
        "icono":"spriteERROR_SRX-B2B-SIF"
    },
    "77":{
        "nombre":"Error SRX-SAB",
        "descripcion":"No se encontró el patrón SRX-SAB",
        "icono":"spriteERROR_SRX-SAB"
    },
    "78":{
        "nombre":"Error SRX-SAB-SIF",
        "descripcion":"No se encontró el patrón SRX-SAB-SIF",
        "icono":"spriteERROR_SRX-SAB-SIF"
    },
    "79":{
        "nombre":"Error SRX-SAB-B2B",
        "descripcion":"No se encontró el patrón SRX-SAB-B2B",
        "icono":"spriteERROR_SRX-SAB-B2B"
    },
    "80":{
        "nombre":"Error SRX-SAB-B2B-SIF",
        "descripcion":"No se encontró el patrón SRX-SAB-B2B-SIF",
        "icono":"spriteERROR_SRX-SAB-B2B-SIF"
    },
    "81":{
        "nombre":"Error TOM",
        "descripcion":"No se encontró el patrón TOM",
        "icono":"spriteERROR_TOM"
    },
    "82":{
        "nombre":"Error TOM-SIF",
        "descripcion":"No se encontró el patrón TOM-SIF",
        "icono":"spriteERROR_TOM-SIF"
    },
    "83":{
        "nombre":"Error TOM-B2B",
        "descripcion":"No se encontró el patrón TOM-B2B",
        "icono":"spriteERROR_TOM-B2B"
    },
    "84":{
        "nombre":"Error TOM-B2B-SIF",
        "descripcion":"No se encontró el patrón TOM-B2B-SIF",
        "icono":"spriteERROR_TOM-B2B-SIF"
    },
    "85":{
        "nombre":"Error TOM-SAB",
        "descripcion":"No se encontró el patrón TOM-SAB",
        "icono":"spriteERROR_TOM-SAB"
    },
    "86":{
        "nombre":"Error TOM-SAB-SIF",
        "descripcion":"No se encontró el patrón TOM-SAB-SIF",
        "icono":"spriteERROR_TOM-SAB-SIF"
    },
    "87":{
        "nombre":"Error TOM-SAB-B2B",
        "descripcion":"No se encontró el patrón TOM-SAB-B2B",
        "icono":"spriteERROR_TOM-SAB-B2B"
    },
    "88":{
        "nombre":"Error TOM-SAB-B2B-SIF",
        "descripcion":"No se encontró el patrón TOM-SAB-B2B-SIF",
        "icono":"spriteERROR_TOM-SAB-B2B-SIF"
    },
    "89":{
        "nombre":"Error TOM-SRX",
        "descripcion":"No se encontró el patrón TOM-SRX",
        "icono":"spriteERROR_TOM-SRX"
    },
    "90":{
        "nombre":"Error TOM-SRX-SIF",
        "descripcion":"No se encontró el patrón TOM-SRX-SIF",
        "icono":"spriteERROR_TOM-SRX-SIF"
    },
    "91":{
        "nombre":"Error TOM-SRX-B2B",
        "descripcion":"No se encontró el patrón TOM-SRX-B2B",
        "icono":"spriteERROR_TOM-SRX-B2B"
    },
    "92":{
        "nombre":"Error TOM-SRX-B2B-SIF",
        "descripcion":"No se encontró el patrón TOM-SRX-B2B-SIF",
        "icono":"spriteERROR_TOM-SRX-B2B-SIF"
    },
    "93":{
        "nombre":"Error TOM-SRX-SAB",
        "descripcion":"No se encontró el patrón TOM-SRX-SAB",
        "icono":"spriteERROR_TOM-SRX-SAB"
    },
    "94":{
        "nombre":"Error TOM-SRX-SAB-SIF",
        "descripcion":"No se encontró el patrón TOM-SRX-SAB-SIF",
        "icono":"spriteERROR_TOM-SRX-SAB-SIF"
    },
    "95":{
        "nombre":"Error TOM-SRX-SAB-B2B",
        "descripcion":"No se encontró el patrón TOM-SRX-SAB-B2B",
        "icono":"spriteERROR_TOM-SRX-SAB-B2B"
    },
    "96":{
        "nombre":"Error TOM-SRX-SAB-B2B-SIF",
        "descripcion":"No se encontró el patrón TOM-SRX-SAB-B2B-SIF",
        "icono":"spriteERROR_TOM-SRX-SAB-B2B-SIF"
    },
    "200":{
        "nombre":"OK",
        "descripcion":"",
        "icono":"spriteOK"
    },
    "204":{
        "nombre":"No Content",
        "descripcion":"",
        "icono":"spriteOK_204"
    },
    "301":{
        "nombre":"Redirección Permanente",
        "descripcion":"",
        "icono":"sprite301"
    },
    "302":{
        "nombre":"Redireccionado",
        "descripcion":"",
        "icono":"spriteREDIRECCIONANDO_302"
    },
    "304":{
        "nombre":"Not Modified",
        "descripcion":"",
        "icono":"sprite304"
    },
    "307":{
        "nombre":"Movido Temporalmente",
        "descripcion":"",
        "icono":"sprite307"
    },
    "400":{
        "nombre":"Error 400",
        "descripcion":"Requerimiento sintácticamente incorrecto",
        "icono":"sprite400"
    },
    "401":{
        "nombre":"Error 401",
        "descripcion":"Acceso no autorizado",
        "icono":"sprite401"
    },
    "403":{
        "nombre":"Error 403",
        "descripcion":"Permiso denegado",
        "icono":"sprite403"
    },
    "404":{
        "nombre":"Error 404",
        "descripcion":"Página no encontrada",
        "icono":"sprite404"
    },
    "405":{
        "nombre":"Error 405",
        "descripcion":"Método de acceso no autorizado",
        "icono":"sprite405"
    },
    "406":{
        "nombre":"Error 406",
        "descripcion":"Página inaceptable",
        "icono":"sprite406"
    },
    "407":{
        "nombre":"Error 407",
        "descripcion":"Falló identificación en proxy",
        "icono":"sprite407"
    },
    "408":{
        "nombre":"Error 408",
        "descripcion":"Tiempo de espera agotado",
        "icono":"sprite408"
    },
    "409":{
        "nombre":"Error 409",
        "descripcion":"Conflicto en la solicitud",
        "icono":"sprite409"
    },
    "410":{
        "nombre":"Error 410",
        "descripcion":"Documento inaccesible",
        "icono":"sprite410"
    },
    "411":{
        "nombre":"Error 411",
        "descripcion":"Longitud requerida",
        "icono":"sprite411"
    },
    "412":{
        "nombre":"Error 412",
        "descripcion":"Condición falsa",
        "icono":"sprite412"
    },
    "413":{
        "nombre":"Error 413",
        "descripcion":"Requerimiento muy grande",
        "icono":"sprite413"
    },
    "414":{
        "nombre":"Error 414",
        "descripcion":"URL muy larga",
        "icono":"sprite414"
    },
    "415":{
        "nombre":"Error 415",
        "descripcion":"Medio no soportado",
        "icono":"sprite415"
    },
    "416":{
        "nombre":"Error 416",
        "descripcion":"Rango no satisfecho",
        "icono":"sprite416"
    },
    "417":{
        "nombre":"Error 417",
        "descripcion":"'expect' no encontrado",
        "icono":"sprite417"
    },
    "439":{
        "nombre":"Error 439",
        "descripcion":"",
        "icono":"sprite439"
    },
    "500":{
        "nombre":"Error 500",
        "descripcion":"Falla interna del servidor",
        "icono":"sprite500"
    },
    "501":{
        "nombre":"Error 501",
        "descripcion":"No implementado",
        "icono":"sprite501"
    },
    "502":{
        "nombre":"Error 502",
        "descripcion":"Error de proxy",
        "icono":"sprite502"
    },
    "503":{
        "nombre":"Error 503",
        "descripcion":"Servicio no disponible",
        "icono":"sprite503"
    },
    "504":{
        "nombre":"Error 504",
        "descripcion":"Timeout de proxy",
        "icono":"sprite504"
    },
    "505":{
        "nombre":"Error 505",
        "descripcion":"No soportado",
        "icono":"sprite505"
    },
    "520":{
        "nombre":"Error 520",
        "descripcion":"Falla interna del servidor",
        "icono":"sprite520"
    },
    "521":{
        "nombre":"Error 521",
        "descripcion":"Falla interna del servidor",
        "icono":"sprite521"
    },
    "522":{
        "nombre":"Error 522",
        "descripcion":"Falla interna del servidor",
        "icono":"sprite522"
    },
    "600":{
        "nombre":"Error desconocido IVR",
        "descripcion":"",
        "icono":"spriteERROR_DESCONOCIDO_IVR"
    },
    "601":{
        "nombre":"Troncal congestionado",
        "descripcion":"Servidor de telefonia caido (congestion).",
        "icono":"spriteTRONCAL_CONGESTIONADO"
    },
    "602":{
        "nombre":"Operador contestó",
        "descripcion":"EL operador atendió la llamada",
        "icono":"spriteOPERADOR_OK"
    },
    "603":{
        "nombre":"Troncal ocupado",
        "descripcion":"",
        "icono":"spriteTRONCAL_OCUPADO"
    },
    "604":{
        "nombre":"Llamada no contestada",
        "descripcion":"No se pudo realizar el monitoreo ya que el troncal no contesto la llamada",
        "icono":"spriteLLAMADA_NO_CONTESTADA"
    },
    "605":{
        "nombre":"Operador no contestó",
        "descripcion":"EL operador no atendió la llamada",
        "icono":"spriteOPERADOR_NO_CONTESTO"
    },
    "607":{
        "nombre":"Timeout",
        "descripcion":"Tiempo de espera de la llamada agotado o silencio del audio mayor al esperado",
        "icono":"spriteTIMEOUT_LLAMADA"
    },
    "610":{
        "nombre":"LLamada colgada",
        "descripcion":"La llamada dura menos de lo presupuestado (corte previo).",
        "icono":"spriteLLAMADA_COLGADA"
    },
    "613":{
        "nombre":"Error de contenido",
        "descripcion":"El contenido del audio capturado no coincide con el patrón.",
        "icono":"spriteLLAMADA_ERROR_DE_CONTENIDO"
    },
    "723":{
        "nombre":"Error patrón imagen",
        "descripcion":"No se encontro el patrón de imagen buscado",
        "icono":"spriteERROR_PATRON_DE_IMAGEN"
    },
    "724":{
        "nombre":"Error patrón imagen inverso",
        "descripcion":"Se encontro un patrón de imagen no esperado o erroneo",
        "icono":"spriteERROR_PATRON_IMAGEN_INVERSO"
    },
    "725":{
        "nombre":"Error patrón imagen OCR",
        "descripcion":"No se encontro el patrón OCR dentro de imagen buscado",
        "icono":"spriteERROR_PATRON_OCR"
    },
    "726":{
        "nombre": "Patrón OCR inverso encontrado",
        "descripcion": "Se encontró patrón de OCR inverso buscado",
        "icono": "spriteERROR_PATRON_OCR_INVERSO"
    },
    "730":{
        "nombre":"Error patrón token",
        "descripcion":"Error en obtención de Token remoto (Correo u aplicación externa)",
        "icono":"spriteERROR_PATRON_TOKEN"
    },
    "999":{
        "nombre":"Sin respuesta desde ISP",
        "descripcion":"Se intento realizar una medicion en ISP, pero no se obtuvo una respuesta. Se asume estado con error para efectos de alertas globales",
        "icono":"spriteSIN_RESPUESTA_DESDE_ISP"
    },
    "1000":{
        "nombre":"Elemento excluído",
        "descripcion":"None",
        "icono":"spriteELEMENTO_EXCLUIDO"
    },
    "1001":{
        "nombre":"Conexión Rechazada",
        "descripcion":"Conexión Rechazada",
        "icono":"spriteCONEXION_RECHAZADA"
    },
    "1002":{
        "nombre":"Servidor Cerró Conexión",
        "descripcion":"Servidor Cerró Conexión",
        "icono":"spriteSERVIDOR_CERRO_CONEXION"
    },
    "1003":{
        "nombre":"Servidor no Encontrado",
        "descripcion":"Servidor no Encontrado",
        "icono":"spriteSERVIDOR_NO_ENCONTRADO"
    },
    "1004":{
        "nombre":"Timeout en Conexión",
        "descripcion":"Timeout en Conexión",
        "icono":"spriteTIMEOUT_EN_CONEXION"
    },
    "1005":{
        "nombre":"Elemento del Servidor No Encontrado",
        "descripcion":"A pesar que el servidor web indico que existía el elemento interno o externo, este no puedo ser encontrado",
        "icono":"spriteELEMENTO_DEL_SERVIDOR_NO_ENCONTRADO"
    },
    "1006":{
        "nombre":"Timeout de la Operación del Socket",
        "descripcion":"Se intento recuperar un elemento interno o externo que indico el elemento principal, pero el primero no respondió y no se pudo concretar la operación del socket. (puede darse el caso que este haya respondido correctamente al inicio",
        "icono":"spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET"
    },
    "1007":{
        "nombre":"Petición Cancelada",
        "descripcion":"Se intento recuperar un elemento interno o externo que indico el elemento principal. pero la petición a este fue rechazada (por lo general pasa por scripts alojados en servidores de terceros)",
        "icono":"spritePETICION_CANCELADA"
    },
    "1010":{
        "nombre":"Host de Destino Inalcanzable (Ping)",
        "descripcion":"No existe una ruta válida hacia el host solicitado por el comando ping.",
        "icono":"spriteHOST_DE_DESTINO_INALCANZABLE_(PING)"
    },
    "1011":{
        "nombre":"Timeout en Petición (Ping)",
        "descripcion":"Hubo timeout en petición, no se recibió respuesta ICMP a comando ping.",
        "icono":"spriteTIMEOUT_EN_PETICION_(PING)"
    },
    "1012":{
        "nombre":"No se Pudo Encontrar Host (Ping)",
        "descripcion":"Ping no pudo determinar la dirección IP para el host provisto.",
        "icono":"spriteNO_SE_PUDO_ENCONTRAR_HOST_(PING)"
    },
    "1999":{
        "nombre":"Error de Red Desconocido",
        "descripcion":"Error de Red Desconocido",
        "icono":"spriteERROR_DE_RED_DESCONOCIDO"
    },
    "2000":{
        "nombre":"Sin Medicion",
        "descripcion":"Sin Medicion. No se pudo obtener status del monitoreo",
        "icono":"spriteSIN_MEDICION"
    },
    "3000":{
        "nombre":"marcado cliente",
        "descripcion":"Periodo marcado por el cliente",
        "icono":"spriteMARCADO_CLIENTE"
    },
    "9999":{
        "nombre":"Error desconocido IVR",
        "descripcion":"Error desconocido IVR",
        "icono":"spriteERROR_DESCONOCIDO_IVR_9999"
    },
    "999999":{
        "nombre":"Error desconocido en Script",
        "descripcion":"Error desconocido en Script",
        "icono":"spriteERROR_DESCONOCIDO_EN_SCRIPT"
    }
}
